module.exports = __webpack_public_path__ + "img/facebook.bf744e3c.png";